import { render, staticRenderFns } from "./addOwnerMember.vue?vue&type=template&id=2c071fbf&scoped=true"
import script from "./addOwnerMember.vue?vue&type=script&lang=js"
export * from "./addOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./addOwnerMember.vue?vue&type=style&index=0&id=2c071fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c071fbf",
  null
  
)

export default component.exports